import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';

const Blog = () => {
    const posts = [
        {
            category: "Implementación",
            title: "Hue llega a Lo Barnechea: Una nueva era de gestión municipal",
            excerpt: "La municipalidad adopta nuestra plataforma para reducir los tiempos de respuesta en un 40%.",
            date: "28 Nov, 2025",
            image: "https://placehold.co/600x400/9e5799/ffffff?text=Lo+Barnechea"
        },
        {
            category: "Casos de Éxito",
            title: "Cómo Providencia eliminó los microbasurales en tiempo récord",
            excerpt: "Gracias a los reportes de vecinos, se identificaron y limpiaron 50 puntos críticos en un mes.",
            date: "15 Nov, 2025",
            image: "https://placehold.co/600x400/ebf2ff/9e5799?text=Providencia"
        },
        {
            category: "Tecnología",
            title: "Inteligencia Artificial para predecir fallas en luminarias",
            excerpt: "Nuestro nuevo algoritmo ayuda a las cuadrillas a realizar mantenimiento preventivo antes de que las luces fallen.",
            date: "02 Nov, 2025",
            image: "https://placehold.co/600x400/bfc2a3/403d5c?text=IA+Hue"
        },
        {
            category: "Comunidad",
            title: "Entrevista: María, la vecina que reportó 100 problemas",
            excerpt: "Conoce a la usuaria más activa de La Reina y cómo su compromiso cambió su barrio.",
            date: "25 Oct, 2025",
            image: "https://placehold.co/600x400/F2EDFC/9e5799?text=Comunidad"
        }
    ];

    return (
        <div className="min-h-screen bg-hue-bg font-roboto text-hue-font pb-20">
            {/* Hero */}
            <div className="bg-white pt-32 pb-16 px-6 rounded-b-[3rem] shadow-sm mb-12">
                <div className="max-w-6xl mx-auto">
                    <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-tight">Blog</h1>
                    <p className="text-xl text-slate-500 max-w-2xl">
                        Historias sobre ciudades más inteligentes, vecinos conectados y el futuro de la gestión municipal.
                    </p>
                </div>
            </div>

            {/* Posts Grid */}
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid md:grid-cols-2 gap-8">
                    {posts.map((post, idx) => (
                        <div key={idx} className="bg-white rounded-[2.5rem] overflow-hidden shadow-lg hover:shadow-xl transition group cursor-pointer border border-slate-100 flex flex-col h-full">
                            <div className="h-64 overflow-hidden relative">
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                                />
                                <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-md px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider text-hue-purple shadow-sm">
                                    {post.category}
                                </div>
                            </div>
                            <div className="p-8 flex flex-col flex-grow">
                                <div className="flex items-center text-slate-400 text-sm mb-4 gap-2">
                                    <Clock size={16} />
                                    {post.date}
                                </div>
                                <h2 className="text-2xl font-bold mb-4 leading-tight group-hover:text-hue-purple transition">
                                    {post.title}
                                </h2>
                                <p className="text-slate-500 mb-6 flex-grow">
                                    {post.excerpt}
                                </p>
                                <div className="flex items-center font-bold text-hue-purple group-hover:translate-x-2 transition">
                                    Leer más <ArrowRight size={20} className="ml-2" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Blog;
